import jwtDecode from 'jwt-decode';
import querystring from 'query-string';

function getAccessToken() {
    return window.sessionStorage.getItem('access_token');
}

function getJWT() {
    const access_token = getAccessToken();
    if (access_token === null) {
        return null;
    }
    return jwtDecode(access_token);
}

function hasScope(scope) {
    const jwt = getJWT();
    if (jwt === null) {
        return false;
    }

    for (let s of jwt.scope.split(' ')) {
        if (s === scope) {
            return true;
        }
    }
    return false;
}

function getDomain() {
    const jwt = getJWT();
    if (jwt !== null) {
        return jwt.iss;
    }

    const cachedDomain = window.sessionStorage.getItem('domain');
    if (cachedDomain) {
        return cachedDomain;
    }

    const query = querystring.parse(window.location.search.substring(1));
    if (query.domain) {
        return query.domain;
    }

    return process.env.REACT_APP_DDX_DOMAIN;
}

function getSessionState() {
    return window.sessionStorage.getItem('session_state');
}

export default {
    getAccessToken: getAccessToken,
    getJWT: getJWT,
    hasScope: hasScope,
    getDomain: getDomain,

    getSessionState: getSessionState
}
